import { render, staticRenderFns } from "./ChatOpened.vue?vue&type=template&id=f75e8cb4&scoped=true"
import script from "./ChatOpened.vue?vue&type=script&lang=js"
export * from "./ChatOpened.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75e8cb4",
  null
  
)

export default component.exports